import React from 'react';
import { ArrowUpRight, CalendarDays, Check, Users, WandSparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const experiences = [
  'Live circles and workshops, held together in real time',
  'Always-available journeys you can move through whenever you’re ready',
  'Seasonal and themed gatherings',
  'Guided experiences across astrology, healing, manifestation, and more, each one built toward an outcome',
];

const membership = [
  'A range of themes to match what you’re working on right now',
  'Each membership guided by a practitioner who specializes in that path',
  'Ongoing community and support built around the theme you choose',
];

const OurServices = () => (
  <section className="bg-white py-20 text-purple-950 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <article id="experiences" className="scroll-mt-24 border-b border-purple-100 pb-16 sm:pb-24">
        <div className="grid gap-10 lg:grid-cols-[0.7fr_1.3fr] lg:items-start">
          <div>
            <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-full bg-purple-900 text-yellow-300">
              <WandSparkles className="h-6 w-6" />
            </div>
            <p className="mb-4 text-xs font-semibold uppercase tracking-[0.35em] text-purple-600">Experiences</p>
            <h2 className="font-title text-4xl font-bold text-purple-900 sm:text-5xl">A guided journey, far beyond a single session.</h2>
            <p className="mt-6 text-lg leading-8 text-purple-800/75">
              Whether you join live or move through it on your own time, every Experience is built to take you somewhere and get you real results.
            </p>
            <Link to="/experiences" className="mt-8 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.14em] text-purple-700 hover:text-purple-950">
              See upcoming Experiences <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
          <ul className="grid gap-4 sm:grid-cols-2">
            {experiences.map((item) => (
              <li key={item} className="rounded-2xl border border-purple-100 bg-[#f8f4ff] p-6 text-base leading-7 text-purple-900/80">
                <Check className="mb-4 h-5 w-5 text-purple-600" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      </article>

      <article id="membership" className="scroll-mt-24 border-b border-purple-100 py-16 sm:py-24">
        <div className="grid gap-10 lg:grid-cols-[1.3fr_0.7fr] lg:items-start">
          <div className="order-2 grid gap-4 sm:grid-cols-3 lg:order-1">
            {membership.map((item) => (
              <div key={item} className="rounded-2xl border border-yellow-200 bg-yellow-50 p-6 text-base leading-7 text-purple-900/80">
                <Check className="mb-4 h-5 w-5 text-yellow-600" />
                {item}
              </div>
            ))}
          </div>
          <div className="order-1 lg:order-2">
            <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-full bg-yellow-400 text-purple-950">
              <CalendarDays className="h-6 w-6" />
            </div>
            <p className="mb-4 text-xs font-semibold uppercase tracking-[0.35em] text-purple-600">Membership</p>
            <h2 className="font-title text-4xl font-bold text-purple-900 sm:text-5xl">For the seeker who wants a home, beyond a single appointment.</h2>
            <p className="mt-6 text-lg leading-8 text-purple-800/75">
              Choose from a variety of themed memberships, each led by a different practitioner, and get ongoing access to community, experiences, and support so your growth has somewhere to live between sessions.
            </p>
            <Link to="/membership" className="mt-8 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.14em] text-purple-700 hover:text-purple-950">
              Explore Membership <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
        <p className="mx-auto mt-10 max-w-2xl text-center font-title text-2xl italic leading-9 text-purple-800">
          “Being part of my membership circle has kept me consistent in a way I always struggled to manage on my own.” <span className="not-italic text-base">— April K.</span>
        </p>
      </article>

      <article id="community" className="scroll-mt-24 pt-16 sm:pt-24">
        <div className="mx-auto max-w-3xl rounded-3xl bg-purple-900 px-7 py-12 text-center text-white sm:px-12">
          <div className="mx-auto mb-6 flex h-12 w-12 items-center justify-center rounded-full bg-yellow-400 text-purple-950">
            <Users className="h-6 w-6" />
          </div>
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.35em] text-yellow-300">Community</p>
          <h2 className="font-title text-4xl font-bold sm:text-5xl">This is a gathering place first.</h2>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-white/75">
            Ask questions, share what you’re moving through, and get supported by people who are on the same path. You draw from the collective wisdom of the whole network, beyond any single practitioner.
          </p>
          <Link to="/membership" className="mt-8 inline-flex items-center gap-2 rounded-lg border border-yellow-300/50 px-6 py-3 text-sm font-semibold uppercase tracking-[0.14em] text-yellow-200 transition hover:bg-yellow-300/10">
            Join the Community <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </article>
    </div>
  </section>
);

export default OurServices;